import moment from 'moment';

// Catalogues moment des langues du site. Nécessaires pour écrire les mois dans la bonne
// langue (sous-titre de couverture, dates du livre) : côté navigateur, webpack n'embarque
// pas le chargement paresseux de moment, et sans ces imports seuls l'anglais et le
// français (défini à la main dans util/date.js) étaient disponibles.
//
// Charger un catalogue appelle moment.defineLocale, qui bascule aussi la locale globale.
// On mémorise donc la locale courante avant les require et on la restaure ensuite, sinon
// tout le formatage de dates sans locale explicite (messages, emails, admin) partirait
// dans la dernière langue chargée. Les require sont volontaires : un import ES serait
// remonté au-dessus de la lecture de la locale courante.
const previousLocale = moment.locale();

require('moment/locale/fr');
require('moment/locale/de');
require('moment/locale/es');
require('moment/locale/it');
require('moment/locale/nl');
require('moment/locale/pt');
require('moment/locale/ja');
require('moment/locale/ko');

moment.locale(previousLocale);

export default moment;
